const Technologies = Vue.component('technologies', {
    template: `
        <div>
            <div class="row title">
                <div class="col techTitle">
                    <h4>
                        {{ $language.familyNum.replace('[FAMILYNUMBER]', family) }}&nbsp;<i class="fas fa-angle-right"></i>&nbsp;{{ $language.classesTitle.replace('[SYSTEM]', system.toUpperCase()) }}
                    </h4>

                    <div @click="swapClass($event)">
                        <div class="custom-control custom-switch systemSwitch">
                            <label class="IPCLabel">IPC</label>
                            <input type="checkbox" class="custom-control-input" :checked="system == 'cpc'">
                            <label class="custom-control-label CPCLabel">CPC</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main" id="technologies">
                <div class="row links" v-if="classes.length > 0">
                    <div class="col-12 tuto">
                        {{ $language.hover }}
                    </div>
                    <div class="col-md-5 classes">

                        <div class="link" v-for="tech in classes" v-if="tech">
                            <span @mouseover="cpcHovered(tech, $event)">
                                <router-link :to="'/' + family + '/technologies/' + system + '/' + encodeURIComponent(tech)">
                                    {{ tech }}
                                </router-link>
                            </span>
                        </div>

                    </div>
                    <div class="col-md-7">

                        <div class="row cpcs" v-if="$store.state.concepts.length > 0">
                            {{ $language.fields }}:
                            <div class="col-12 concept" v-for="concept in $store.state.concepts">
                                {{ concept }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    {{ $language.classNotFound.replace('[SYSTEM]', system.toUpperCase()) }}
                </div>
                <classdescription :system="system"></classdescription>
            </div>
        </div>
    `,

    computed: {
        family() {
            return this.$route.params.family;
        },
        classes() {
            return this.$store.getters.classes;
        }
    },

    data: function() {
        return {
            system: 'cpc'
        };
    },

    mounted: function() {
        this.$store.commit('addLoadedComponent', 'Technologies');

        this.getTechs();

        EventBus.$on('newFamily', () => {
            this.getTechs();
        });

    },

    methods: {
        getTechs() {
            this.$store.commit('showLoading');

            axios.get('?page=getData&action=classes', {
                    params: {
                        family: this.family,
                        system: this.system
                    }
                })
                .then(response => {

                    let qId = (this.system == 'cpc')?'cpcSubgroupByFamily':'ipcSubgroupByFamily';

                    let classes = [];

                    response.data[qId].forEach(bucket => {
                        classes.push(bucket.val);
                    });

                    if (classes.length > 0) {
                        classes.sort();
                    }

                    this.$store.commit('saveClasses', classes);

                    qId = (this.system == 'cpc')?'cpcFieldByFamily':'ipcFieldByFamily';

                    var concepts = [];

                    for (var concept in response.data) {
                        if (response.data.hasOwnProperty(concept)) {
                        }
                    }

                    response.data[qId].forEach(bucket => {
                        concepts.push(bucket.val);
                    });

                    if (concepts.length > 0) {
                        concepts.sort();
                    }

                    this.$store.commit('saveConcepts', concepts);

                    this.$store.commit('hideLoading');


                })
                .catch(err => {
                    console.log(err);
                });
        },

        cpcHovered: function(tech, event) {

            var timer = setTimeout(() => {
                this.getDescription(tech, this.system, event.target)
            }, 500);

            event.target.onmouseout = function() {
                clearTimeout(timer);
            }

        },

        getDescription: function(tech, system, target) {

            axios.get('?page=getData&action=classDesc', {
                    params: {
                        class: tech,
                        system
                    }
                })
                .then(response => {

                    EventBus.$emit('new_class', response.data.description, tech, target)
                })
                .catch(err => {
                    console.log(err);
                });
        },

        swapClass(e) {

            e.preventDefault();

            if (this.system == 'cpc') {
                this.system = 'ipc'
            } else {
                this.system = 'cpc'
            }

            this.$store.commit('changeCurrentSystem', this.system);

            this.getTechs();



        }

    }
});
